export const SplitIOTreatments = {
  isSelectClaimEnabled: 'sa_loginweb_selectclaim',
}
